var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "emd-container _highlight_header" }, [
      _c("div", { staticClass: "emd-container__header" }, [
        _c("h2", { staticClass: "emd-text _size_default _type_caption" }, [
          _vm._v(" " + _vm._s(_vm.$t("title")) + " "),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "eu-ml_3 eu-mb_1" },
        [
          _vm.transactions.length > 0
            ? _c("transaction-timeline-item", {
                attrs: { transactions: _vm.transactions },
                on: { item: _vm.openDrawer },
              })
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }